import NProgress from 'nprogress';
import router from '@/router';
import {
  getToken,
} from '@/utils/auth';
import { domTitle, setDocumentTitle } from '@/utils/util';

import 'nprogress/nprogress.css';

NProgress.configure({
  template: "<div class='bar' role='bar' style='background:#1890FF'></div>",
  showSpinner: false,
});

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (to.meta && typeof to.meta.title !== 'undefined') {
    setDocumentTitle(`${to.meta.title} - ${domTitle}`);
  }
  if (getToken()) {
    if (to.path === '/user/login') {
      next({ path: '/' });
    } else {
      next();
    }
  } else if (to.path !== '/user/login') {
    next({ path: '/user/login' });
  } else {
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
